export const withTimeout = <T>(
  promise: Promise<T>,
  timeout: number,
  message = 'promise timed out'
): Promise<T> => {
  let timeoutId: NodeJS.Timeout

  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error(message)), timeout)
  })

  return Promise.race([
    promise.finally(() => clearTimeout(timeoutId)), // Clear the timer when the promise settles
    timeoutPromise,
  ])
}
